/* Prime Raw — product card size pills: set the variant id and update the price. */
if (!customElements.get('pr-card-variants')) {
  customElements.define(
    'pr-card-variants',
    class PrCardVariants extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.form = this.closest('form');
        this.card = this.closest('.pr-pcard');
        this.querySelectorAll('.pr-pcard__pill').forEach(function (pill) {
          pill.addEventListener('click', function () { self.select(pill); });
        });
      }

      select(pill) {
        this.querySelectorAll('.pr-pcard__pill').forEach(function (p) { p.setAttribute('aria-pressed', p === pill ? 'true' : 'false'); });
        var input = this.form.querySelector('input[name="id"]');
        input.value = pill.dataset.id;
        input.disabled = false;
        var price = this.card.querySelector('[data-pr-price]');
        if (price) {
          price.innerHTML = (pill.dataset.compare ? '<s>' + pill.dataset.compare + '</s>' : '') + '<span>' + pill.dataset.price + '</span>';
        }
        var unit = this.card.querySelector('[data-pr-unit]');
        if (unit && pill.dataset.unit) unit.textContent = pill.dataset.unit;
      }
    }
  );
}
